<template>
  <div>
    <ApplyNavbar></ApplyNavbar>
    <nuxt style="padding-top: 85px" />
  </div>

</template>

<script>
import ApplyNavbar from "../components/ApplyNavbar";
export default {
  name: "apply",
  components:{
    ApplyNavbar
  }
}
</script>

<style scoped>

</style>